"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = exports.getDeliveryLocalData = exports.getDeliveryData = exports.getLoanRequestInitialData = void 0;
const config_1 = require("../config/config");
const BaseRequest_1 = __importDefault(require("../http-requests/BaseRequest"));
const ServiceBaseUrl = `${config_1.API_URL}/loan-request-delivery`;
const getLoanRequestInitialData = (codAcervo, campus, bibliotecas, cancelToken) => __awaiter(void 0, void 0, void 0, function* () {
    return BaseRequest_1.default.axiosInst.get(`${ServiceBaseUrl}`, {
        headers: BaseRequest_1.default.publicHeaders(),
        cancelToken,
        params: {
            codAcervo,
            campus,
            bibliotecas,
        },
    });
});
exports.getLoanRequestInitialData = getLoanRequestInitialData;
const getDeliveryData = (codBiblioteca, cancelToken) => __awaiter(void 0, void 0, void 0, function* () {
    return BaseRequest_1.default.axiosInst.get(`${ServiceBaseUrl}/delivery-data`, {
        headers: BaseRequest_1.default.publicHeaders(),
        cancelToken,
        params: {
            codBiblioteca,
        },
    });
});
exports.getDeliveryData = getDeliveryData;
const getDeliveryLocalData = (codBiblioteca, local, cancelToken) => __awaiter(void 0, void 0, void 0, function* () {
    return BaseRequest_1.default.axiosInst.get(`${ServiceBaseUrl}/delivery-local-data`, {
        headers: BaseRequest_1.default.publicHeaders(),
        cancelToken,
        params: {
            codBiblioteca,
            local,
        },
    });
});
exports.getDeliveryLocalData = getDeliveryLocalData;
const store = (codAcervo, data, cancelToken) => __awaiter(void 0, void 0, void 0, function* () {
    return BaseRequest_1.default.axiosInst.post(`${ServiceBaseUrl}/store/${codAcervo}`, data, {
        // @ts-ignore
        headers: BaseRequest_1.default.privateHeaders(),
    });
});
exports.store = store;
